import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, map, of, switchMap, tap } from 'rxjs';
import { Md5 } from 'ts-md5';
import { LoggedUser } from '../models/logged-user';
import { environment } from '../../../environments/environment';
import { MeUser } from '../models/me-user';
import * as jwt from 'jose';
import { clearHistory } from '../../store/history/history.actions';
import {Store} from "@ngrx/store";


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  _userSubject: BehaviorSubject<MeUser> = new BehaviorSubject(new MeUser({}));
  _tokenSubject: BehaviorSubject<string> = new BehaviorSubject('');
  _powerBITokenSubject: BehaviorSubject<string> = new BehaviorSubject('');
  isRememberMeChecked: boolean = false;

  constructor(private http: HttpClient, private store: Store) {
    const token = localStorage.getItem('token') ?? '';
    const user = localStorage.getItem('currentUser') ?? '';
    if (user != '' && token != '') {
      this.setUserDetails(user);
      this.setTokenValue(token);
    }
  }

  private encryptHeaders(password: string, username: string) {
    let passwordMD5 = Md5.hashStr(password);
    let authB64 = btoa(`${username}:${passwordMD5}`);
    let header = new HttpHeaders({
      'Authorization': `Basic ${authB64}`,
      'Accept': 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=utf-8',
      'Cache-Control': 'no-cache,no-store',
      'Pragma': 'no-cache'
    });
    return header;
  }

  loginSSO(token: string) {
    //this.store.dispatch(clearHistory());
    localStorage.setItem('sso', "true");
    this.setTokenValue(token);
    const tokenUser = jwt.decodeJwt<any>(token);

    const loggedUser:LoggedUser= {
      ...tokenUser
    };
    const mergedUser = {
      ...loggedUser,
      email: tokenUser.sub,
      roles: tokenUser.roles
    }

    this.setUserDetails(mergedUser);
    return mergedUser;
  }

    login(userGroup: { username: string; password: string; isRememberMeChecked: boolean }): Observable<LoggedUser | MeUser | null> {
    //this.store.dispatch(clearHistory());
    const _headers = this.encryptHeaders(userGroup.password, userGroup.username);
    localStorage.removeItem("sso");
    return this.http.get<LoggedUser>(`${environment.csibefrontend}login`, { headers: _headers }).pipe(
      map((response) => {
        this.setTokenValue(response?.token ?? "");
        this.setCurrentUser(userGroup);
        const tokenUser = jwt.decodeJwt<any>(response.token);
        const mergedUser = {
          ...response,
          email: tokenUser.sub,
          roles: tokenUser.roles
        }
        this.setUserDetails(mergedUser);
        return mergedUser;
      }),
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  isLoggedIn() {
    const token = localStorage.getItem("token");
    return !!token;
  }

  private setUserDetails(user?: LoggedUser | string) {
    if (user) {
      let currentUser: MeUser;
      if (typeof user == 'string') {
        localStorage.setItem("currentUser", user);
        let userDetails: Record<string, string> = JSON.parse(user);
        currentUser = new MeUser(userDetails);
      }else {
        localStorage.setItem("currentUser", JSON.stringify(user));
        currentUser = new MeUser(user);
        //this.matomo.initialize(user)
      }
      this._userSubject.next(currentUser)



    }
    else {
      localStorage.removeItem("currentUser");
      this._tokenSubject.next('');
    }
  }

  private setCurrentUser(userGroup: { username: string; password: string; isRememberMeChecked: boolean }) {
    const user = {
      username: userGroup.username,
      password: userGroup.password,
      isRememberMeChecked: userGroup.isRememberMeChecked,
    };
    localStorage.setItem(
      "currentUser",
      JSON.stringify(userGroup.isRememberMeChecked ? user : "")
    );
  }

  private setTokenValue(token?: string) {
    if (token) {
      localStorage.setItem("token", token);
      this._tokenSubject.next(token);
    }
    else {
      localStorage.removeItem("token");
      this._tokenSubject.next('');
    }
  }

  resetUser() {
    this.setTokenValue();
    this._userSubject.next(new MeUser({}));
    this.isRememberMeChecked = false;
  }

  resetToken() {
    this.setTokenValue();
    this.setUserDetails();
  }


}
